var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0754 19.4201H6.67541C6.33101 19.4201 6.04541 19.1346 6.04541 18.7902C6.04541 18.4458 6.33101 18.1602 6.67541 18.1602H15.0754C15.4198 18.1602 15.7054 18.4458 15.7054 18.7902C15.7054 19.1346 15.4198 19.4201 15.0754 19.4201Z",
    fill: "url(#paint0_linear_1414_1606)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8904 5.57721L14.5304 7.9796C14.0852 8.29879 13.4468 8.1056 13.2536 7.5932L11.666 3.35962C11.3972 2.62882 10.364 2.62882 10.0952 3.35962L8.49922 7.5848C8.30602 8.1056 7.67603 8.29879 7.23083 7.9712L3.87085 5.56881C3.19885 5.09841 2.30845 5.76201 2.58565 6.5432L6.08003 16.3292C6.19763 16.6651 6.51683 16.8835 6.86963 16.8835H14.8748C15.2276 16.8835 15.5468 16.6567 15.6644 16.3292L19.1588 6.5432C19.4444 5.76201 18.554 5.09841 17.8904 5.57721ZM12.9764 13.3304H8.77642C8.43202 13.3304 8.14642 13.0448 8.14642 12.7004C8.14642 12.356 8.43202 12.0704 8.77642 12.0704H12.9764C13.3208 12.0704 13.6064 12.356 13.6064 12.7004C13.6064 13.0448 13.3208 13.3304 12.9764 13.3304Z",
    fill: "url(#paint1_linear_1414_1606)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1414_1606",
    x1: 10.8754,
    y1: 18.1602,
    x2: 10.8754,
    y2: 19.4201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCB69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1414_1606",
    x1: 10.8737,
    y1: 2.81152,
    x2: 10.8737,
    y2: 16.8835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCB69"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.0acb798816615b9add74e8c5e4db13f4.svg";
export { ForwardRef as ReactComponent };